import { request } from 'root/common/request.js';
import Config from 'root/common/config/config';

export function isMember(params) {
    return request({
        url: Config.api.isMember,
        method: 'get',
        params,
        isNeedLoading: false,
        isNeedToken: true,
    });
}
